// @ts-nocheck — TODO: tipizzare (S6) — Element vs HTMLElement
// ====== F3: filtro persistente "I miei clienti" ======
// Aggiunge un toggle nella vista Clienti che filtra a quelli dove l'utente
// loggato risulta come CPL, PM1, PM2, tecnico, o è la risorsa associata.
// Persistito su localStorage per ricordarsi la scelta fra sessioni.

const LS_KEY = 'mase.mei.miClienti.on';

function isMeiOn() {
  try {
    return localStorage.getItem(LS_KEY) === '1';
  } catch (_) {
    return false;
  }
}
function setMeiOn(v) {
  try {
    localStorage.setItem(LS_KEY, v ? '1' : '0');
  } catch (_) {
    /* ignore */
  }
}

function clienteCoinvolge(c, me) {
  if (!c || !me) return false;
  const name = me.name || '';
  const resName = me.resourceName || '';
  if (c.cpl === name) return true;
  if (c.pm1 === name) return true;
  if (c.pm2 === name) return true;
  if ((c.tecnici || []).includes(name)) return true;
  if ((c.tecnici || []).includes(resName)) return true;
  if (resName && c.accessi && Object.keys(c.accessi).includes(resName)) return true;
  return false;
}

function ensureToggle() {
  if (document.getElementById('toggleMeiClienti')) return;
  const filters = document.querySelector('#view-clienti .filters');
  if (!filters) return;
  const wrap = document.createElement('label');
  wrap.id = 'toggleMeiClientiWrap';
  wrap.className = 'segmented';
  wrap.style.cssText = 'gap:6px;align-items:center;padding:0 4px;';
  wrap.innerHTML = `<button type="button" id="toggleMeiClienti" aria-pressed="${isMeiOn()}" class="${isMeiOn() ? 'active' : ''}" title="Mostra solo i clienti dove sono coinvolto come CPL/PM/tecnico/risorsa">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:middle;margin-right:4px;" aria-hidden="true">
      <path d="M20 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M4 21v-2a4 4 0 0 1 3-3.87"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>I miei clienti
  </button>`;
  // Inserisci prima del wrapper export a destra
  const rightTools = filters.querySelector('div[style*="margin-left"]');
  if (rightTools) filters.insertBefore(wrap, rightTools);
  else filters.appendChild(wrap);

  wrap.querySelector('#toggleMeiClienti').addEventListener('click', () => {
    const next = !isMeiOn();
    setMeiOn(next);
    const btn = wrap.querySelector('#toggleMeiClienti');
    btn.classList.toggle('active', next);
    btn.setAttribute('aria-pressed', String(next));
    // @ts-ignore — renderClienti globale
    if (typeof renderClienti === 'function') renderClienti();
  });
}

// Hook su renderClienti per applicare il filtro: lo intercettiamo a-priori,
// mostrando l'esito in input filterRisorsa = nome.cognome quando attivo.
// Per non rompere logica esistente: estendiamo il `globalThis.getFilteredClienti`
// quando definito; altrimenti facciamo wrap del rendering.
const _origRenderClienti = globalThis.renderClienti;
if (typeof _origRenderClienti === 'function') {
  globalThis.renderClienti = function () {
    ensureToggle();
    _origRenderClienti.apply(this, arguments);
    if (!isMeiOn()) return;
    // Applica filtro post-render sulla tbody (semplice e non distruttivo)
    // @ts-ignore — state globale
    const me = typeof getCurrentUser === 'function' ? getCurrentUser() : null;
    if (!me) return;
    const tbody = document.getElementById('tbodyClienti');
    if (!tbody) return;
    // @ts-ignore
    const allowed = new Set(
      (state?.clients || []).filter((c) => clienteCoinvolge(c, me)).map((c) => c.nome)
    );
    let kept = 0;
    tbody.querySelectorAll('tr').forEach((tr) => {
      const nm = tr.dataset.cliente || tr.querySelector('[data-cliente]')?.dataset.cliente;
      if (!nm) return;
      if (allowed.has(nm)) kept++;
      else tr.style.display = 'none';
    });
    // Update count line (se presente)
    const countLine = document.getElementById('clientiCount');
    if (countLine)
      countLine.textContent = `${kept} client${kept === 1 ? 'e' : 'i'} (filtro "I miei clienti")`;
  };
}

// Inserisci toggle al primo accesso clienti se la vista è già visibile
document.addEventListener('DOMContentLoaded', ensureToggle);

// @ts-ignore — global
Object.assign(globalThis, { isMeiOn, setMeiOn, ensureMeiToggle: ensureToggle });
export {};
